// Npm modules
import { useState, useEffect, FC, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
// Components
import GradientButton from "../login/components/GradientButton";
// Shared components
import GradientText from "../../shared/GradientText/GradientText";
import InputGradientext from "../../shared/GradientTextInput/GradientTextInput";

// Selectors
import { getLoading } from "../../../selectors";
// Utilities
import { isEmailValid } from "../../../utilities/customFunctions";
// Style component
import { ErrorMessage } from "../login/styled.component";
// Scss
import styles from "../login/Login.module.scss";
import { getSelfEnrolmentData } from "../../../selectors";

interface IAnonymousLoginProps {
  heading: any;
  contentChildren: any;
  proceedActionHandler: (email: string) => void;
  // showError: boolean;
  // errorMessage: string;
}

const Login: FC<IAnonymousLoginProps> = (props: IAnonymousLoginProps) => {
  // local state
  const [email, setEmail] = useState("");
  const [isEmailFormatValid, setIsEmailFormatValid] = useState(true);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  // action dispatch function
  const dispatch = useDispatch();

  // selectors
  const [] = useSelector((store: any) => []);

  // location
  const location = useLocation();

  const [verificationCodeSentFailed, loading] = useSelector((store: any) => [
    getSelfEnrolmentData(store)?.verificationCodeSentFailed,
    getLoading(store),
  ]);

  //TODO: Make this generic
  useEffect(() => {
    if (verificationCodeSentFailed === true) {
      setShowErrorMsg(true);
    }
  }, [verificationCodeSentFailed]);

  const {
    containerAnon,
    containerAnon__login,
    text,
    text__subheader,
    containerAnon__subheader,
    containerAnon__inputs,
    containerAnon__actions,
  } = styles;

  const handleCheckEmail = (email: string) => {
    if (isEmailValid(email)) {
      props.proceedActionHandler(email);
    } else {
      setIsEmailFormatValid(false);
    }
  };

  const isLoginDisabled = () => {
    return email === "";
  };

  return (
    <div className={containerAnon}>
      <div className={containerAnon__login} data-testid="login-containerAnon">
        <GradientText string={props.heading} />

        <div className={containerAnon__subheader}>
          <h2 className={`${text} ${text__subheader}`}>
            {props.contentChildren}
          </h2>
        </div>

        <div className={containerAnon__inputs}>
          <InputGradientext
            name={"email"}
            handleChange={(event: any) => {
              setIsEmailFormatValid(true);
              setShowErrorMsg(false);
              setEmail(event.target.value.trim());
            }}
            placeholder={"Email"}
            propValues={{
              autoComplete: "off",
            }}
          />
        </div>

        {!isEmailFormatValid && (
          <ErrorMessage>
            Incorrect email pattern detected. Please try again.
          </ErrorMessage>
        )}

        {showErrorMsg === true && (
          <ErrorMessage>
            Could not send verification code. Please try again.
          </ErrorMessage>
        )}

        <div className={containerAnon__actions}>
          <GradientButton
            handleClick={() => handleCheckEmail(email)}
            isLoading={loading}
            disabled={isLoginDisabled()}
            testid={"login-button"}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(Login);
